import {styled} from '@mui/material/styles';
import {ABImage} from '@jobseeker/lotus/images';
import {Image} from '@jobseeker/lotus/components/Image';

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const PoweredByABWrapper = styled('div')(({theme}) => ({
  display: 'flex',
  justifyContent:  'flex-end',
  alignItems: 'center',
  marginTop: '10px',
  [theme.breakpoints.down('sm')]: {
    justifyContent: isAppIimjobs ? 'center' : 'flex-end',
  },
}));

const PoweredByText = styled('div')(() => ({
  opacity: 0.4,
  fontSize: '14px',
  fontWeight: 600,
  marginRight: '6px',
}));

const ABLogoImg = styled(Image)(({theme}) => ({
  width: '90px',
  height: '17px',
  cursor: 'pointer',
}));

const PoweredByAmbitionBox = ({
  redirectionUrl = 'https://www.ambitionbox.com/',
  title = 'Ambition Box',
}) => {
  return (
    <PoweredByABWrapper>
      <PoweredByText>Powered by: </PoweredByText>
      <a
        style={{height: 17}}
        title={title}
        target="_blank"
        rel="nofollow"
        href={redirectionUrl}
      >
        <ABLogoImg height={17} width={90} alt="AmbitionBox" src={ABImage} />
      </a>
    </PoweredByABWrapper>
  );
};

export default PoweredByAmbitionBox;
